require('./openYoungCardExpensesByCategoryView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @components
const ExpensesByCategoryInfo = require('components/expenses/expensesByCategoryInfo/expensesByCategoryInfo');
const ExpensesByCategoryTable = require('components/expenses/expensesByCategoryTable/expensesByCategoryTable');
const ExpensesByCategoryFilter = require('components/expenses/expensesByCategoryFilter/expensesByCategoryFilter');
const ExpensesByCategoryFilterApplied = require('components/expenses/expensesByCategoryFilterApplied/expensesByCategoryFilterApplied');
const ExpensesByCategoryTabs = require('components/expenses/expensesByCategoryTabs/expensesByCategoryTabs');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @actions
const expensesActions = require('actions/globalPositionExpensesOld');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const { onlyOpenYoungExpensesCategoriesList } = require('constants/categories');
const MAX_EXPENSES_BY_CATEGORY = 20;
const {
    EURO_TEXT,
    ACCOUNT_INTERVENTION_OWNER,
    CARD_INTERVENTION_OWNER,
    BY_EXPENSES
} = require('constants/index');

class OpenYoungCardBudgetsExpensesView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            category: this.props.match.params.category === 'all-categories' ? '' : this.props.match.params.category,
            filterSettingsOpen: false,
            totalExpensesMonth: this.props.totalExpenses,
            itemsToShow: MAX_EXPENSES_BY_CATEGORY,
            showMore: false,
            creditSelected: true,
            debitSelected: true,
        }

        this.setFilter = this.setFilter.bind(this);
        this.buildAccounts = this.buildAccounts.bind(this);
        this.buildCards = this.buildCards.bind(this);
        this.getTotalMontoCategory = this.getTotalMontoCategory.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.createContents = this.createContents.bind(this);
        this.receiveDataFromServer = this.receiveDataFromServer.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleShowMoreExpenses = this.handleShowMoreExpenses.bind(this);
        this.getDefaultCategory = this.getDefaultCategory.bind(this);
        this.handleRemoveCategory = this.handleRemoveCategory.bind(this);
    }

    componentDidMount() {
        // This is necessary because if the page is reloaded, the total
        // expenses are lost.
        const { match: { params: { cardId, byExpenseOrBudget } }, openYoungBudget } = this.props;
        let filter = {};
        this.props.expensesActions.resetCategories();
        this.props.expensesActions.requestCardExpenses(cardId);

        if (byExpenseOrBudget !== BY_EXPENSES) {
            const budgetSelectedDate = openYoungBudget.get('selectedMonth');
            const budgetSelectedMonth = moment(budgetSelectedDate).get('month');
            const currentMonth = moment().get('month');
            let toDate = moment().startOf('day');
            if (currentMonth !== budgetSelectedMonth) {
                toDate = moment(budgetSelectedDate).endOf('month');
            }
            const previousPeriod = budgetSelectedDate ?
                moment(budgetSelectedDate).startOf('month') :
                moment().startOf('month');
            filter = {
                date: {
                    from: previousPeriod,
                    isActive: true,
                    selected: 'Custom',
                    to: toDate
                }
            }
            this.props.expensesActions.updateFiltersByCategoryAction(filter);
        }

        this.props.expensesActions.requestCardExpensesByCategory(
            this.state.category === '' ? this.getDefaultCategory() : this.state.category,
            cardId
        );
    }

    getDefaultCategory() {
        const { totalCategoryExpenses, totalPreviousExpensesByCategory } = this.props;
        const categoriesListSorted = this.sortCategories(onlyOpenYoungExpensesCategoriesList, totalCategoryExpenses, totalPreviousExpensesByCategory)[0];
        return categoriesListSorted;
    }

    handleChangeCategory(category) {
        const { history, match: { params: { cardId, byExpenseOrBudget } } } = this.props;
        if (category !== this.state.category && category !== '') {
            history.push(`/myprofile/cards/${cardId}/budgets/expenses-by-category/${category}/${byExpenseOrBudget}`)
            this.setState({
                category
            }, () => this.props.expensesActions.requestCardExpensesByCategory(category, cardId));
        }
    }

    handleShowMoreExpenses() {
        const { expensesByCategory } = this.props;
        const itemsToShow = this.state.itemsToShow + MAX_EXPENSES_BY_CATEGORY;

        this.setState({
            itemsToShow,
            showMore: itemsToShow < expensesByCategory.size
        });
    }

    updateContractItem(item, optionalItemValue) {
        const sameName = item.name === optionalItemValue.name;
        const sameNumber = item.number === optionalItemValue.number;
        return Object.assign(item, {
            selected: !!item.selected ? !(sameName && sameNumber) : false
        });
    }

    handleRemoveCategory(categoryKey) {
        const { immFilters, immCards, match: { params: { cardId } } } = this.props;
        const today = moment().startOf('day');
        const immCard = immCards.get(cardId);
        const number = immCard.get('number');

        const beginningOfTime = moment()
            .subtract(11, 'months')
            .startOf('month');

        let filters = immFilters.toJS();

        if (categoryKey === 'date') {
            Object.assign(filters.date, {
                from: beginningOfTime,
                isActive: false,
                selected: 'None',
                to: today
            });
        }

        if (categoryKey === 'contract') {
            Object.assign(filters.contracts, {
                cardsContracts: number
            });

            let contractsActives = filters.contracts.cardsContracts.filter(item => item.selected).length;

            if (contractsActives === 0) {
                Object.assign(filters.contracts, {
                    isActive: false,
                    cardsContracts: number
                });
            }
        }

        if (categoryKey === 'subcategory') {
            Object.assign(filters.subcategory, {
                isActive: false,
                subcategory: 'all'
            });
        }

        this.setFilter(filters);
    }

    getMoreMovementsButton(show) {
        let momentsButton;
        if (show) {
            momentsButton = (
                <div className="card-expenses-by-category__link-container">
                    <div className="card-expenses-by-category__previous-months">
                        <OKButton modifier="link-complementary" onClick={this.handleShowMoreExpenses}>
                            <FormattedText value="cards-seeMoreMovements" />
                        </OKButton>
                    </div>
                </div>
            );
        }

        return momentsButton;
    }

    sortCategories(categories, currentValues, previousValues) {
        let sorted = [];
        let result = categories;

        if (currentValues && previousValues) {
            sorted = categories.map(category => ({
                category,
                currentValue: currentValues.get(category) || 0,
                previousValue: previousValues.get(category) || 0
            })
            );

            sorted.sort((a, b) => {
                if (a.currentValue !== b.currentValue) {
                    return b.currentValue - a.currentValue;
                } else {
                    if (a.previousValue !== b.previousValue) {
                        return b.previousValue - a.previousValue;
                    }

                    let aCleaned = a.category.toUpperCase();
                    let bCleaned = b.category.toUpperCase();

                    return (aCleaned < bCleaned) ? -1 : (aCleaned > bCleaned) ? 1 : 0;
                }
            });

            result = sorted.map(item => item.category);
        }

        return result;
    }

    getTotalMontoCategory() {
        const { expensesByCategory } = this.props;
        let totalMonto = 0;
        expensesByCategory.toJS().map(monto => {
            totalMonto += monto !== undefined ? monto.monto : 0;
        })
        return (totalMonto * -1);
    }

    createContents() {
        const { immFilters, expensesByCategory, immAccounts, immCards, currency } = this.props;
        let movements = expensesByCategory.slice(0, this.state.itemsToShow);
        const totalMovements = expensesByCategory.size;
        const moreMovementsButton = this.getMoreMovementsButton(this.state.showMore);
        let filterApplied;

        if (movements.size === 0) {
            const isDateFiilterActive = immFilters.getIn(['date', 'isActive']);
            let noMovementsMessage = isDateFiilterActive ?
                formatText('openYoungCardExpensesByCategory-emptyStateTextFilter') :
                formatText('openYoungCardExpensesByCategory-emptyMovements');

            filterApplied = (
                <div>
                    <ExpensesByCategoryFilterApplied
                        immFilters={immFilters}
                        onClearFilter={this.handleClearFilter}
                        removeFilter={(filterKey, optionalItemValue) => this.handleRemoveCategory(filterKey, optionalItemValue)}
                    />
                    <EmptyState
                        primaryText={noMovementsMessage}
                        iconType="nointernet-banking" />
                </div>
            );
        } else {
            filterApplied = (
                <div>
                    <ExpensesByCategoryFilterApplied
                        immFilters={immFilters}
                        totalMovementsCategory={totalMovements}
                        totalExpensesCategory={this.getTotalMontoCategory()}
                        currency={currency}
                        onClearFilter={this.handleClearFilter}
                        removeFilter={(filterKey, optionalItemValue) => this.handleRemoveCategory(filterKey, optionalItemValue)}
                    />
                    <ExpensesByCategoryTable
                        expensesByCategory={movements}
                        immAccounts={immAccounts}
                        immCards={immCards}
                    />
                    {moreMovementsButton}
                </div>
            );
        }
        return filterApplied;
    }

    receiveDataFromServer() {
        let content;
        if (this.props.isPartialFetching) {
            content = <LoadingSection />;
        } else {
            content = this.createContents();
        }
        return content;
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    setFilter(filters) {
        const { match: { params: { cardId } } } = this.props;
        this.props.expensesActions.updateFiltersByCategoryAction(filters);
        this.props.expensesActions.requestCardExpenses(cardId);
        this.props.expensesActions.requestCardExpensesByCategory(
            this.state.category === '' ? this.getDefaultCategory() : this.state.category,
            cardId
        );
    }

    handleClearFilter() {
        const { immFilters } = this.props;

        const today = moment()
            .startOf('day');

        const beginningOfTime = moment()
            .subtract(11, 'months')
            .startOf('month');

        let filters = immFilters.toJS();

        Object.assign(filters.date, {
            from: beginningOfTime,
            isActive: false,
            selected: 'None',
            to: today
        });

        this.setFilter(filters);
    }

    buildAccounts() {
        const { immAccounts } = this.props;
        return immAccounts.map(id => {
            const count = id.toJS();
            if (count.balance.currency === EURO_TEXT && count.filters.valid && count.interventionType === ACCOUNT_INTERVENTION_OWNER) {
                return {
                    name: count.description,
                    number: count.iban,
                    selected: true
                };
            }
        });
    }

    buildCards() {
        const { immCards } = this.props;
        return immCards.map(id => {
            const card = id.toJS();
            if (card.filters.valid && card.interventionType === CARD_INTERVENTION_OWNER) {
                return {
                    name: card.alias.current,
                    number: card.number,
                    selected: true
                };
            }
        });
    }

    render() {
        const {
            immCards,
            match: { params: { cardId, category } },
            immFilters, totalExpenses,
            totalPreviousExpensesByCategory,
            totalCategoryExpenses,
            currency,
            expensesByCategory
        } = this.props;
        const dateFilter = immFilters.getIn(['date', 'isActive']);
        const subcategoryFilter = immFilters.getIn(['subcategory', 'isActive']);
        const isAnyActiveFilter = dateFilter || subcategoryFilter;
        const immCard = immCards.get(cardId);
        const subtitleLeft = formatText('cards-expenses');
        const subtitleRight = getLastNChars(immCard.get('number'));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-expenseAndBudget'),
                url: `/myprofile/cards/${cardId}/budgets`
            },
            {
                text: formatText('accountMovements-movementsTitle')
            }
        ];

        const table = this.receiveDataFromServer();
        const categoriesListSorted = this.sortCategories(onlyOpenYoungExpensesCategoriesList, totalCategoryExpenses, totalPreviousExpensesByCategory);
        const defaultCategory = categoriesListSorted[0];
        const totalExpensesByCategory = totalCategoryExpenses ? totalCategoryExpenses.get(this.state.category === 'all-categories' ? defaultCategory : this.state.category) : 0;

        return (
            <div>
                <div className="container-fluid card-movements--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                finalTitle={getFinalTitle('openYoungCardExpenses-headerTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-md-12">
                                <ExpensesByCategoryTabs
                                    categories={categoriesListSorted}
                                    onChangeCategory={this.handleChangeCategory}
                                    totalExpenses={totalExpenses}
                                    totalCategoryExpenses={totalCategoryExpenses}
                                    selectedTab={this.state.category === '' ? defaultCategory : this.state.category}
                                    expensesByCategory={expensesByCategory}
                                />
                                <ExpensesByCategoryInfo
                                    category={category}
                                    categories={categoriesListSorted}
                                    totalExpenses={totalExpenses}
                                    totalExpensesByCategory={totalExpensesByCategory}
                                    totalCategoryExpenses={totalCategoryExpenses}
                                    onOpenFilter={this.handleToggleFilters}
                                    currency={currency}
                                    filter={isAnyActiveFilter}
                                    onHandleClearFilter={this.handleClearFilter}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="card-expenses-by-category__content">
                                    <div className="card-expenses-by-category__title">
                                        <OKBoxTitle value={formatText('accountMovements-movementsTitle')} />
                                    </div>
                                    <div className="card-expenses-by-category__buttons">
                                        {isAnyActiveFilter && <button className="card-expenses-by-category__button-clean" onClick={this.handleClearFilter}>
                                            <FormattedText value="filters-clear" format="uppercase" />
                                        </button>}
                                        <OKButton
                                            id="btn_accountLastMovementsHeader_filterButton"
                                            modifier="task"
                                            onClick={this.handleToggleFilters}>
                                            <i className="icon icon-filtrar card-expenses-by-category--filter-settings-icon" />
                                        </OKButton>
                                    </div>
                                    {table}
                                </div>
                                <ExpensesByCategoryFilter
                                    isOpen={this.state.filterSettingsOpen}
                                    setFilter={this.setFilter}
                                    immFilter={immFilters}
                                    onCloseClick={this.handleToggleFilters}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungCardBudgetsExpensesView.propTypes = {
    currency: PropTypes.string,
    expensesActions: PropTypes.object,
    expenses: PropTypes.object,
    expensesByCategory: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immFilters: PropTypes.object,
    isPartialFetching: PropTypes.bool,
    match: PropTypes.object,
    totalCategoryExpenses: PropTypes.object,
    totalCustomDatesAll: PropTypes.number,
    totalExpenses: PropTypes.number,
    totalPreviousExpenses: PropTypes.number,
    totalPreviousExpensesByCategory: PropTypes.object,
    openYoungBudget: PropTypes.object
};

module.exports.constructor = OpenYoungCardBudgetsExpensesView;

module.exports.OpenYoungCardBudgetsExpensesView = connect(
    state => ({
        immFilters: state.globalPosition.getIn(['expenses', 'filtersByCategory']),
        isPartialFetching: state.globalPosition.getIn(['expenses', 'isPartialFetching']),
        expensesByCategory: state.globalPosition.getIn(['expenses', 'expensesByCategory']),
        currency: state.accounts.getIn(['balance', 0, 'currency']),
        immAccounts: state.accounts.get('byId'),
        immCards: state.cards.get('byId'),
        expenses: state.globalPosition.get('expenses'),
        totalExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'total', 'ALL']),
        totalPreviousExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'previousPeriod', 'total', 'ALL']),
        totalPreviousExpensesByCategory: state.globalPosition.getIn(['expenses', 'expenses', 'previousPeriod', 'byCategory', 'ALL']),
        totalCategoryExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'byCategory', 'ALL']),
        totalCategoryExpensesAll: state.globalPosition.getIn(['expenses', 'expenses']),
        totalCustomDatesAll: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'totalCustomDates', 'ALL']),
        openYoungBudget: state.openYoungBudget
    }),
    dispatch => ({
        expensesActions: bindActionCreators(expensesActions, dispatch)
    })
)(withRouter(OpenYoungCardBudgetsExpensesView));
